
import { motion } from "framer-motion";

export const LoadingSpinner = () => {
  return (
    <div className="text-center py-8 sm:py-12">
      <motion.div 
        className="inline-block text-4xl"
        animate={{ 
          rotate: [0, 10, -10, 10, 0],
          scale: [1, 1.2, 1, 1.2, 1]
        }}
        transition={{ 
          duration: 2,
          repeat: Infinity
        }}
      >
        🧪
      </motion.div>
      <p className="text-base sm:text-lg mt-4 font-medium text-primary-foreground">
        Mixing up some kitchen magic... ✨
      </p>
    </div>
  );
};
